import { FC } from 'react';
import { useRouter } from 'next/router';

import { WatchHeader } from 'components/auctions/CreateAuction/WatchHeader';
import { PricePill } from 'components/common/PricePill';
import { Slideout, SlideoutCommonProps } from 'components/design-system/Slideout';
import { buildListingUrl } from 'lib/url_helpers';
import { Offer } from 'types';

export const FinalOfferSubmittedSlideoutTestIds = {
  container: 'final-offer-submitted-slideout'
} as const;

export type FinalOfferSubmittedSlideoutProps = {
  closeModal: () => void;
  offer: Offer;
  finalPrice: number;
} & SlideoutCommonProps;

export const FinalOfferSubmittedSlideout: FC<FinalOfferSubmittedSlideoutProps> = ({ offer, finalPrice, ...props }) => {
  const { push } = useRouter();
  const url = buildListingUrl(
    offer.listing.model.brand.displayName,
    offer.listing.model.displayName,
    offer.listing.model.referenceNumber,
    offer.listing.id
  );

  const handleViewDetails = () => {
    push(url);
    props.closeModal();
  };

  return (
    <Slideout
      {...props}
      title
      data-testid={FinalOfferSubmittedSlideoutTestIds.container}
      bodyClassName='d-flex flex-column'
      submit={{
        title: 'View details',
        onClick: handleViewDetails
      }}
      customHeader={() => (
        <WatchHeader onClickPrevious={undefined} listing={offer.listing} onClose={props.closeModal} />
      )}
    >
      <div className='riforma-regular text-center flex-1 d-flex flex-column justify-content-around align-items-center'>
        <div>
          <PricePill isDark={false} price={finalPrice} />
          <h4 className='fs-18px fs-sm-20px my-4'>Final Offer live now for 24 hours</h4>
          <div className='opacity-60 mx-2 line-height-24px mb-5 mt-2 px-4'>
            We’ve updated the price of your watch to reflect your Final Offer price. This is now promoted to relevant
            users.
          </div>
        </div>
      </div>
    </Slideout>
  );
};
